import $ from "./jquery";

$(function () {
  $(".js-flb-estl-collapsible-field").each(function () {
    const $this = $(this);
    const $toggler = $this.find(".js-flb-estl-collapsible-field-toggle");
    const $content = $this.find(".js-flb-estl-collapsible-field-content");

    $toggler.on("click", function () {
      if($this.hasClass('open')){
        $this.removeClass('open');
        $content.slideUp(200);
      }else{
        $this.addClass('open');
        $content.slideDown(200);
      }
    });
  });
});
